import { Asset, FirmAssetBalanceStatistics } from '@tassat/fred-definitions';
import { LfFirmStatsMapped } from '@tassat/fred-extended-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import {
    getAssets,
    getFirmAssetStats,
    getLiquidityFacilityStats
} from './common';
import { getLFFirmsArray } from './firms';

const getFirmId = (_state: AdminState | ClientState, firmId: string) => firmId;

export const getFirmAssetStatsFromFirmId = createSelector(
    [ getFirmAssetStats, getFirmId ],
    (firmAssetStats, firmId): FirmAssetBalanceStatistics[] => {
        if (!firmAssetStats) {
            return [];
        }

        return Object.values(firmAssetStats)
            .flatMap(id => Object.values(id))
            .filter(relationship => relationship.FirmId === firmId);
    }
);

export const getFirmLiquidityFacilityStats = createSelector(
    [ getLFFirmsArray, getLiquidityFacilityStats, getAssets ],
    (lfFirms, lfStats, assets): Array<LfFirmStatsMapped> => {
        return lfFirms.map((lfFirm) => {
            const firmLfStats = Object.values(lfStats[lfFirm.FirmId] ?? {});
            const statsWithAsset = firmLfStats.map((stats) => ({
                stats,
                asset: assets[stats.AssetId] as Asset
            }));

            return {
                firm: lfFirm,
                statsWithAsset
            };
        });
    }
);